import { Cubit } from "blac-next";
import { StorageController } from "src/state/StorageBloc/StorageBloc";

const STORAGE_KEY = "sophieIntroCard.dismissed";
const STORAGE_VALUE = "true";

export interface SophieIntroCardState {
  isDismissed: boolean;
  isSheetOpen: boolean;
}

const initialState: SophieIntroCardState = {
  isDismissed: false,
  isSheetOpen: false
};

export default class SophieIntroCardCubit extends Cubit<SophieIntroCardState> {
  constructor() {
    super(initialState);
    this.init();
  }

  private init = (): void => {
    const stored = StorageController.getItem(STORAGE_KEY);
    if (stored === STORAGE_VALUE) {
      this.patch({ isDismissed: true });
    }
  };

  dismiss = (): void => {
    StorageController.setItem(STORAGE_KEY, STORAGE_VALUE);
    this.patch({ isDismissed: true, isSheetOpen: false });
  };

  openSheet = (): void => {
    this.patch({ isSheetOpen: true });
  };

  closeSheet = (): void => {
    this.patch({ isSheetOpen: false });
  };
}
